<template>
  <div class="box">
    <div class="box-title">
      <img src="../../../assets/app/title.png" alt="">
      <font>业务实时数据</font>
    </div>
    <div class="box-tabs">
      <mt-swipe :auto="0">
        <mt-swipe-item>99元套餐1</mt-swipe-item>
        <mt-swipe-item>99元套餐2</mt-swipe-item>
        <mt-swipe-item>99元套餐</mt-swipe-item>
      </mt-swipe>
      <img class="right" src="../../../assets/app/right.png" alt="">
    </div>
    <div id="myBusinessChart" class="businessLine"></div>
    <div class="box-data">
      <div class="box-data-item ">
        <img class="item-img" src="../../../assets/app/yesday.png" alt="">
        <div class="box-datas">
          <div class="box-data-title">昨日累计</div>
          <div class="box-data-data">6666</div>
        </div>
      </div>
      <div class="box-data-item">
        <img class="item-img" src="../../../assets/app/today.png" alt="">
        <div class="box-datas">
          <div class="box-data-title">今日累计</div>
          <div class="box-data-data">6666</div>
        </div>
      </div>
      <div class="box-data-item">
        <img class="item-img" src="../../../assets/app/precent.png" alt="">
        <div class="box-datas">
          <div class="box-data-title"><img src="../../../assets/app/blueUp.png" alt=""> 比昨日</div>
          <div class="box-data-data">6666</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'mint-ui';
// 引入基本模板
import echarts from "echarts/lib/echarts";
// 引入拆线图组件
import "echarts/lib/chart/line";
// 引入提示框、legend和title组件
import "echarts/lib/component/tooltip";
// import "echarts/lib/component/title";
import "echarts/lib/component/legend";

export default {
  props: ['list'],
  data () {
    return {}
  },
  props: ['xData', 'yDataSame', 'yDataRing'],
  watch: {
    xData () {
      this.drawLine(this.xData, this.yDataSame, this.yDataRing)
    }
  },
  mounted () {
    this.drawLine(this.xData, this.yDataSame, this.yDataRing)
  },
  methods: {
    drawLine (xData, yDataSame, yDataRing) {
      // 基于准备好的dom，初始化echarts实例
      // const myBusinessChart = this.$echarts.init(document.getElementById('myBusinessChart'))
      const myBusinessChart = echarts.init(document.getElementById('myBusinessChart'))
      const option = {
        //提示框  
        tooltip: {
          // //触发类型：坐标轴触发  
          trigger: 'axis',
          // trigger: 'item',
          backgroundColor: 'rgba(255,255,255,1)', //通过设置rgba调节背景颜色与透明度  
          color: '#43484D',
          borderWidth: 1,
          borderRadius: 5,
          borderColor: '#eee',
          shadowColor: 'rgba(0, 0, 0, 0.5)',
          shadowBlur: 10,
          shadowOffsetY: 20,
          padding: 0,
          textStyle: {
            color: '#43484D',
          },
          position ([x, y]) { //提示框位置指定
            // console.log('x', x)
            // console.log('y', y)
            return [x - 45, y - 45]
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#9dcae9',
              width: 1,
              type: 'dashed'
            },
            crossStyle: {
              color: '#9dcae9',
              width: 1,
              type: 'dashed'
            },
            shadowStyle: {
              color: 'rgba(150,150,150,0.3)',
              width: 1,
              type: 'default'
            }
          },
          formatter (data) {
            // console.log('data[0].dataIndex', data[0].dataIndex)
            const index = data[0].dataIndex
            let domData = `<div class='business-tips'><div class='business-tips-top'> ${xData[index]} </div> <br/> <div class='business-tips-content'> 小&nbsp;&nbsp;&nbsp;时: <font class='color-yellow'>${yDataRing[index]} </font> <br/>  日累计:  <font class='color-green'> ${yDataSame[index]} </font></div></div>`

            return domData //将小数转化为百分数显示
          },
          // extraCssText:'background:rgba(0, 0, 0, 0.5);'  
        },
        color: ["#86D8DD", "#0384DF"], //线条的主颜色
        // legend: { //指标位置
        //   x: '59%',
        //   y: '5%',
        //   data: ["环比", "同比"]
        // },
        calculable: true,
        xAxis: [{
          type: 'category',
          boundaryGap: true, //xAxis中的boundaryGap属性，设置为false代表是零刻度开始，设置为true代表离零刻度间隔一段距离
          axisLabel: {
            interval: 0, //横轴信息全部显示 
            color: "#86939E" //刻度线标签颜色
          },
          axisTick: { //坐标轴刻度相关设置
            show: true, //是否显示坐标轴刻度。
            alignWithLabel: true, //类目轴中在 boundaryGap 为 true 的时候有效，可以保证刻度线和标签对齐
            interval: 'auto', //坐标轴刻度的显示间隔，在类目轴中有效。默认会采用标签不重叠的策略间隔显示标签。可以设置成 0 强制显示所有标签。如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推
            inside: true, //坐标轴刻度是否朝内，默认朝外。
            // length:5,                //坐标轴刻度的长度。
            // lineStyle:mylineStyle
          },
          axisLine: {
            lineStyle: {
              color: '#e2e2e2',
              width: 1, //这里是为了突出显示加上的  
            }
          },
          data: xData
        }],
        yAxis: [

          {
            show: false,
            type: 'value',
            splitLine: { // 控制网格线是否显示
              show: false
            },
            axisLabel: {
              color: "#86939E" //刻度线标签颜色
            },
            axisTick: { //坐标轴刻度相关设置
              show: false, //是否显示坐标轴刻度。
              alignWithLabel: true, //类目轴中在 boundaryGap 为 true 的时候有效，可以保证刻度线和标签对齐
              interval: 'auto', //坐标轴刻度的显示间隔，在类目轴中有效。默认会采用标签不重叠的策略间隔显示标签。可以设置成 0 强制显示所有标签。如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推
              inside: true, //坐标轴刻度是否朝内，默认朝外。
              // length:5,                //坐标轴刻度的长度。
              // lineStyle:''
            },
            axisLine: {
              lineStyle: {
                color: '#e2e2e2',
                width: 1, //这里是为了突出显示加上的  
              }
            },
          }
        ],
        series: [{
          name: '环比',
          type: 'line',
          // stack: '总量',
          //smooth : false,
          //symbol: null,         // 拐点图形类型
          symbolSize: 5, // 拐点图形大小
          //symbolRotate : null,  // 拐点图形旋转控制
          showAllSymbol: false, // 标志图形默认只有主轴显示（随主轴标签间隔隐藏策略）
          itemStyle: {
            normal: {
              // color: 各异,
              label: {
                show: false
                // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
                //           'inside'|'left'|'right'|'top'|'bottom'
                // textStyle: null      // 默认使用全局文本样式，详见TEXTSTYLE
              },
              lineStyle: {
                width: 2,
                type: 'solid',
                shadowColor: 'rgba(0,0,0,0)', //默认透明
                shadowBlur: 5,
                shadowOffsetX: 3,
                shadowOffsetY: 3
              }
            },
            emphasis: {
              // color: 各异,
              label: {
                show: false
                // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
                //           'inside'|'left'|'right'|'top'|'bottom'
                // textStyle: null      // 默认使用全局文本样式，详见TEXTSTYLE
              }
            }
          },
          data: yDataRing
        },
        {
          name: '同比',
          type: 'line',
          // stack: '总量',
          //smooth : false,
          //symbol: null,         // 拐点图形类型
          symbolSize: 5, // 拐点图形大小
          //symbolRotate : null,  // 拐点图形旋转控制
          showAllSymbol: false, // 标志图形默认只有主轴显示（随主轴标签间隔隐藏策略）
          itemStyle: {
            normal: {
              // color: 各异,
              label: {
                show: false
                // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
                //           'inside'|'left'|'right'|'top'|'bottom'
                // textStyle: null      // 默认使用全局文本样式，详见TEXTSTYLE
              },
              lineStyle: {
                width: 2,
                type: 'solid',
                shadowColor: 'rgba(0,0,0,0)', //默认透明
                shadowBlur: 5,
                shadowOffsetX: 3,
                shadowOffsetY: 3
              }
            },
            emphasis: {
              // color: 各异,
              label: {
                show: false
                // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
                //           'inside'|'left'|'right'|'top'|'bottom'
                // textStyle: null      // 默认使用全局文本样式，详见TEXTSTYLE
              }
            }
          },
          data: yDataSame
        }
        ]
      };

      // 绘制图表
      myBusinessChart.setOption(option);
    }
  }
}

</script>
<style lang="less">
@font-color1: #43484d; //标题
@font-color2: #86939e; //一般文字
@font-color3: #0384df; //蓝色
@font-color4: #fff; //白色
.box-title {
  color: @font-color1;
  height: 0.84rem;
  line-height: 0.84rem;
  text-align: center;
  font-size: 0.31rem;
  font-family: "PingFang-SC-Heavy";
  border-bottom: 0.02rem solid #eee;
  img {
    position: relative;
    width: 0.33rem;
    top: 0.05rem;
    margin-right: 0.1rem;
  }
}

.box-tabs {
  position: relative;
  height: 0.8rem;
  .mint-swipe {
    width: 1.5rem;
    overflow: visible;
  }
  .mint-swipe-indicators {
    position: absolute;
    bottom: -0.4rem;
    left: 0.25rem;
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  .mint-swipe-items-wrap > div {
    top: 0.28rem;
    left: 0.23rem;
    font-size: 0.28rem;
  }
  .mint-swipe-indicator.is-active {
    background: @font-color3;
    opacity: 1;
  }
  .right {
    height: 0.31rem;
    width: 0.15rem;
    position: absolute;
    right: 0.35rem;
    top: 0.25rem;
  }
}

.box-data {
  height: 1.5rem;
  padding: 0.2rem 0.22rem;
  .box-data-item {
    float: left;
    position: relative;
    height: 1.36rem;
    width: 1.24rem;
    border: 0.02rem solid #eee;
    padding-left: 1rem;
    -webkit-box-shadow: 0 0 0.1rem #eee;
    box-shadow: 0 0 0.1rem #eee;
    margin-right: 0.1rem;
    .item-img {
      position: absolute;
      left: 0.32rem;
      top: 0.56rem;
      width: 0.28rem;
    }
    .box-datas {
      width: 1.3rem;
    }
    .box-data-title {
      margin-top: 0.27rem;
      font-size: 0.22rem;
      color: @font-color2;
      img {
        width: 0.15rem;
        height: 0.26rem;
      }
    }
    .box-data-data {
      margin-top: 0.1rem;
      font-size: 0.42rem;
      color: @font-color3;
    }
  }
  .box-data-item:last-child {
    margin-right: 0.02rem;
  }
}

.businessLine {
  height: 3.5rem; // width: 7rem;
  width: 100%; // margin-left: 0.25rem;
}

.business-tips {
  width: 1.7rem;
  padding: 0.07rem 0.2rem;
  box-shadow: 0.1rem 0.1rem 0.1rem #ccc;
}

.business-tips-content {
  font-family: "PingFang-SC-Medium";
  color: #43484d;
  font-size: 0.25rem;
  margin-top: -0.15rem;
}

.business-tips-top {
  color: #43484d;
  border-bottom: 0.02rem solid #eaeaea;
  text-align: center;
}

.color-yellow {
  margin-left: 0.19rem; // color: #FC9D2E;
}

.color-green {
  margin-left: 0.19rem; // color: #269513;
}

.font-style {
}
</style>



// WEBPACK FOOTER //
// src/components/app/index/business.vue